import { all, call } from "redux-saga/effects";
import {userSagas} from "./user/user.sagas";
import {gridSagas} from "./grid/grid.sagas";

export default function* rootSaga(){
    yield all([call(userSagas), call(gridSagas)]);
}